module.exports = __webpack_public_path__ + "media/images/icons/check-circle-5f48bd2b7aa8e0f33a74c94c49f37451.svg";